module.exports = __webpack_public_path__ + "3892ab93940e282d2e9edc2e88f841a5.svg";